import React from "react";
import { image_url } from "../../utils/ImageUrl";
import { TrimText } from "../common/TrimText";
import { BaseText, Heading4, MediumText, TextLink } from "../common/GlobalElements/Typography";
import { tokens } from "../../public/tokens";

export default function TeamProfile(props) {
  const { team, profile } = props;

  return (
    <>
      <div className="support-team-box">
        <div className="support-team-top">
          <div className="support-team-icon" title={team?.name || "NA"}>
            <img src={image_url(team?.picture)} />
          </div>

          <div className="support-team-detail">
            <Heading4 fontWeight={tokens.typography.fontWeights.bold} className="mb-0" title={team.name || "NA"}>
              {(team && team.name) && team.name}
            </Heading4>
            {profile == "coach" ? <BaseText as="p" className="support-team-subject m-0">Programme Coordinator</BaseText>  : null}
            {profile == "lecturer" ? <BaseText as="p" className="support-team-subject m-0">Subject Lecturer</BaseText> : null}
            {profile == "support" ? <BaseText as="p" className="support-team-subject m-0">Programme Support</BaseText> : null}
            {(team && team.email) ? 
              <TextLink className="support-team-email" title={team?.email} href={"mailto:" + team.email}>{team?.email}</TextLink> 
            : null}
          </div>
        </div>
        {team && team.about ? <MediumText as="p" className="mb-1" title={team?.about}>
          {team && team.about ? TrimText(team?.about,170) : "NA"}
        </MediumText> : null}
      </div>
    </>
  );
}
